import styled from 'styled-components';

import type { Rarity } from '__generated__/globalTypes';
import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { getRewardImageUrl } from 'lib/rewards';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nd-150);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nd-50);
  display: flex;
  &:hover {
    background: var(--c-nd-100);
  }
`;

type Props = {
  value: number;
  rarity: Rarity;
};
export const EssenceBalance = ({ value, rarity }: Props) => {
  return (
    <Root>
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={value} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <img
            src={getRewardImageUrl('shard', rarity)}
            alt=""
            width={16}
            height={16}
          />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
